import { render, staticRenderFns } from "./bookmark_icon.vue?vue&type=template&id=a2ec8a46&"
import script from "./bookmark_icon.vue?vue&type=script&lang=js&"
export * from "./bookmark_icon.vue?vue&type=script&lang=js&"
import style0 from "./bookmark_icon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports